export default function MyBrandIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 14.38"
      className="nineteen"
    >
      <g id="a" />
      <g id="b">
        <g id="c">
          <path
            id="d"
            d="M8,14.38c-.16,0-.33-.04-.47-.13-1.1-.66-2.14-1.42-3.12-2.25-1.74-1.32-3.13-3.05-4.03-5.04C-.51,4.67,.11,1.6,2.67,.41,4.52-.44,6.71,.06,8,1.64,9.29,.06,11.48-.44,13.33,.41c2.56,1.19,3.18,4.26,2.29,6.55-.91,1.99-2.29,3.72-4.03,5.04-.98,.83-2.02,1.58-3.12,2.25-.14,.08-.3,.13-.47,.13M4.54,1.31c-.46,0-.91,.1-1.32,.29-1.84,.85-2.27,3.2-1.62,4.89,.83,1.78,2.08,3.33,3.65,4.51,.86,.73,1.78,1.4,2.74,2,.96-.6,1.88-1.27,2.74-2,1.57-1.18,2.83-2.73,3.66-4.51,.66-1.69,.23-4.04-1.62-4.89-1.58-.73-3.46-.04-4.19,1.54l-.59,1.29-.59-1.29c-.52-1.12-1.64-1.83-2.87-1.83"
            fill="#333"
          />
        </g>
      </g>
    </svg>
  );
}
